import type { Notification } from '@/api/notifications';

export const NOTIFICATION_GROUP_ORDER = [
  'today',
  'yesterday',
  'thisWeek',
  'earlier',
] as const;

export type NotificationGroup = (typeof NOTIFICATION_GROUP_ORDER)[number];

export interface GroupedNotifications {
  group: NotificationGroup;
  items: Notification[];
}

function dateGroup(iso: string): NotificationGroup {
  const d = new Date(iso);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const weekAgo = new Date(today);
  weekAgo.setDate(today.getDate() - 7);
  const itemDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  if (itemDay >= today) return 'today';
  if (itemDay >= yesterday) return 'yesterday';
  if (itemDay >= weekAgo) return 'thisWeek';
  return 'earlier';
}

/** Buckets a feed page into Today / Yesterday / This week / Earlier, keeping
 *  the incoming order inside each bucket and dropping empty buckets. */
export function groupNotifications(
  items: Notification[],
): GroupedNotifications[] {
  const map = new Map<NotificationGroup, Notification[]>();
  for (const item of items) {
    const g = dateGroup(item.createdAt);
    if (!map.has(g)) map.set(g, []);
    map.get(g)!.push(item);
  }
  return NOTIFICATION_GROUP_ORDER.filter(g => map.has(g)).map(g => ({
    group: g,
    items: map.get(g)!,
  }));
}
